import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'; 

@Injectable({
  providedIn: 'root'
})
export class DashboadService {

  constructor(private http: HttpClient) { }

  apiURL = environment.BACKEND_URL + '/dashboard'; 

  getUserDashboard(): Observable<any>{
    return this.http.get(`${this.apiURL}`); 
  }
}
